import { createSlice } from "@reduxjs/toolkit";

const showAllSlice = createSlice({
  name: "showAll",
  initialState: {
    value: false,
  },
  reducers: {
    setShowAll(state, action) {
      state.value = action.payload;
    },
    toggleShowAll(state) {
      state.value = !state.value;
    }
  }
});

export const { setShowAll, toggleShowAll } = showAllSlice.actions;

export default showAllSlice.reducer;
